import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames/bind";
import styles from "./Header.module.css";
import images from "~/assets";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";
import { ToastContext } from "~/components/context/ToastContext";
import { BASE_AUTH_URL, BASE_HEADER_URL } from "~/helper/apiService";

const cx = classNames.bind(styles);

function Header({ totalAvailable }) {
  const { showToast } = useContext(ToastContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [route, setRoute] = useState("");
  const [contact, setContact] = useState("");
  const [formData, setFormData] = useState({
    route: "",
    contact: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // State to track login status

  // Fetch initial header data and check login status on mount
  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch("https://xanh19.com/header.php");
        if (!response.ok) {
          throw new Error("Không thể tải dữ liệu header");
        }
        const data = await response.json();
        setRoute(data.route);
        setContact(data.contact);
      } catch (error) {
        console.error("Error fetching header data:", error);
        showToast(error.message || "Không thể tải dữ liệu header", "error");
      } finally {
        setIsLoading(false);
      }
    };

    const checkLoginStatus = async () => {
      try {
        const response = await fetch(`${BASE_AUTH_URL}check-login`, {
          credentials: "include", // Include cookies in the request
        });
        if (response.ok) {
          const data = await response.json();
          console.log("lgoin");
          setIsLoggedIn(true); // User is logged in
        } else {
          setIsLoggedIn(false); // User is not logged in
        }
      } catch (error) {
        console.error("Error checking login status:", error);
        setIsLoggedIn(false);
      }
    };

    fetchHeaderData();
    checkLoginStatus();
  }, [showToast]);

  const openModal = () => {
    setFormData({ route, contact });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(BASE_HEADER_URL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Không thể cập nhật tiêu đề");
      }
      const data = await response.json();
      setRoute(data.route);
      setContact(data.contact);
      closeModal();
      showToast("Cập nhật tiêu đề thành công", "success");
    } catch (error) {
      console.error("Error updating header:", error);
      showToast(error.message || "Lỗi khi tiêu đề header", "error");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={cx("header")}>
      <div className={cx("header-content")}>
        <div className={cx("logo-container")}>
          <img
            src={images.logoGioVang}
            alt="Giờ Vàng Xanh 19 Logo"
            className={cx("logo")}
          />
        </div>
        <div className={cx("header-text")}>
          <h1 className={cx("title")}>Vòng Quay Xanh 19</h1>
          <h2 className={cx("route")}>
            {isLoading ? (
              <div className={cx("placeholder", "route-placeholder")} />
            ) : (
              route
            )}
          </h2>
          <p className={cx("contact")}>
            {isLoading ? (
              <div className={cx("placeholder", "contact-placeholder")} />
            ) : (
              <a>{contact}</a>
            )}
          </p>
          {isLoggedIn && ( // Conditionally render edit icon
            <FontAwesomeIcon
              icon={faEdit}
              className={cx("edit-icon")}
              onClick={openModal}
              aria-label="Edit header content"
            />
          )}
        </div>
      </div>

      {isModalOpen && (
        <div className={cx("modal-overlay")} onClick={closeModal}>
          <div className={cx("modal")} onClick={(e) => e.stopPropagation()}>
            <div className={cx("modal-header")}>
              <h2 className={cx("modal-title")}>Chỉnh sửa nội dung</h2>
              <FontAwesomeIcon
                icon={faTimes}
                className={cx("close-icon")}
                onClick={closeModal}
                aria-label="Close modal"
              />
            </div>
            <form onSubmit={handleSubmit}>
              <div className={cx("form-group")}>
                <label className={cx("form-label")}>Tiêu đề 1</label>
                <input
                  type="text"
                  name="route"
                  value={formData.route}
                  onChange={handleInputChange}
                  className={cx("form-input")}
                  placeholder="Nhập tiêu đề 1"
                />
              </div>
              <div className={cx("form-group")}>
                <label className={cx("form-label")}>Tiêu đề 2</label>
                <input
                  type="text"
                  name="contact"
                  value={formData.contact}
                  onChange={handleInputChange}
                  className={cx("form-input")}
                  placeholder="Nhập tiêu đề 2"
                />
              </div>
              <div className={cx("modal-actions")}>
                <button
                  type="button"
                  onClick={closeModal}
                  className={cx("modal-button", "cancel")}
                >
                  Hủy
                </button>
                <button type="submit" className={cx("modal-button", "confirm")}>
                  Lưu
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
